module.exports = __webpack_public_path__ + "img/logo_tam_color.6dc557bf.png";